import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBubbleSpikeAlt = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 5,
	height: 10,
	viewBox: "0 0 5 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5 0V4.99991V9.99981C5 9.99981 4 9.99981 0 9.99981C0 9.99981 5 5.49951 5 0Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgBubbleSpikeAlt);
export { ForwardRef as ReactComponent };
